import { render, staticRenderFns } from "./desc_list.vue?vue&type=template&id=6b8271a3&scoped=true"
import script from "./desc_list.vue?vue&type=script&lang=ts"
export * from "./desc_list.vue?vue&type=script&lang=ts"
import style0 from "./desc_list.vue?vue&type=style&index=0&id=6b8271a3&prod&lang=css"
import style1 from "./desc_list.vue?vue&type=style&index=1&id=6b8271a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8271a3",
  null
  
)

export default component.exports